import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';

const styles = () => ({
  root: {},
});

const OnboardingNavigatorNextButton = ({
  className,
  classes,
  onClick,
  disabled,
  buttonLabel,
  isLoading,
  ...rest
}) => {
  return (
    <RoundedButton
      onClick={onClick}
      className={classNames(classes.root, className)}
      disableElevation
      variant="contained"
      disabled={disabled}
      isLoading={isLoading}
      color={'primary'}
      fullWidth
      test={'onboarding-navigator-next-button'}
      size={DS_SIZE_MAP.sm}
      {...rest}
    >
      {buttonLabel}
    </RoundedButton>
  );
};

OnboardingNavigatorNextButton.defaultProps = {
  className: '',
  isLoading: false,
  buttonLabel: 'Continue',
};

OnboardingNavigatorNextButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  buttonLabel: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default withStyles(styles)(OnboardingNavigatorNextButton);
